class MFRActiveSelector {
  constructor(i, e, observer, callback) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      selector: ".has-active-selector__selector",
      activeSelector: ".has-active-selector__selector.is-active"
    };

    this.observer = observer;
    this.moveActiveSelector = callback;

    this.init();
  }

  init() {
    this.$selector = this.$element.find(this.selectors.selector);
    this.$activeSelector = this.$element.find(this.selectors.activeSelector);

    window.onWidthResize(() => { 
      this.$activeSelector = this.$element.find(this.selectors.activeSelector);
      this.moveActiveSelector(this.$element, this.$activeSelector);
    });
    this.moveActiveSelector(this.$element,this.$activeSelector);

    this.$element.closest( ".reveal" ).on( "open.zf.reveal", () => {
      const activeSelector = this.$element.find(this.selectors.activeSelector);
      this.moveActiveSelector(this.$element, activeSelector);
    } );

    this.initObserver();
  }

  initObserver() {
    this.$selector.each((index, element) => {
      this.observer.observe($(element).get(0), {
        attributes: true,
        attributeFilter: ["style", "class"],
      });
    });
  }
}

jQuery( () => {
  let callback = (parent,element) => {
    if (!parent.length || !element.length || !element.is( ":visible" ) ) {
      if (parent.find(".has-active-selector__selector").length <= 1) {
        parent.hide();
      }
      return;
    }
    const { top, left } = element.position();
    const width = element.width();
    const height = element.height();

    parent.css({
      "display": "flex",
      "--indicator-top-position": `${top}px`,
      "--indicator-left-position": `${left}px`,
      "--indicator-width": `${width}px`,
      "--indicator-height": `${height}px`,
    });
  }
  let activeSelectorObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutationRecord) => {
      if ($(mutationRecord.target).hasClass("is-active")) {
        const element = $(mutationRecord.target);
        const parent = element.closest(".has-active-selector");

        callback(parent, element);
      }
    });
  });

  $(".has-active-selector" ).each( ( i, e ) => {
    const mfrActiveSelector = new MFRActiveSelector( i, e, activeSelectorObserver, callback );
  } );
} );